import { FeatureFlagConfigModel } from 'frontend-toolkit';

export enum FeatureFlags {
  PARTICIPANT_GROUP_RESTRICTION = 'PARTICIPANT_GROUP_RESTRICTION',
  PARTICIPANT_GROUP_CAPACITY_LIMIT = 'PARTICIPANT_GROUP_CAPACITY_LIMIT',
  COUPON_CODES = 'COUPON_CODES',
  AUTOMATIC_DISCOUNTS = 'AUTOMATIC_DISCOUNTS',
  DUPLICATE_FORM_REG_2 = 'DUPLICATE_FORM_REG_2',
  OFFLINE_PAYMENTS = 'OFFLINE_PAYMENTS',
  AUTO_ROSTERING = 'AUTO_ROSTERING',
  TABLE_REVAMP = 'TABLE_REVAMP',
  ORG_INVOICING = 'ORG_INVOICING',
  ADD_ONS = 'ADD_ONS',
  NGB_INTEGRATIONS = 'NGB_INTEGRATIONS',
  FEE_SUMMARY_EXPORT = 'FEE_SUMMARY_EXPORT',
  HCR_REG_2 = 'HCR_REG_2',
}

export const FeatureFlagConfig: Record<FeatureFlags, FeatureFlagConfigModel> = {
  [FeatureFlags.PARTICIPANT_GROUP_RESTRICTION]: {
    id: FeatureFlags.PARTICIPANT_GROUP_RESTRICTION,
    enabled: false,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471, 36681, 37503],
  },
  [FeatureFlags.PARTICIPANT_GROUP_CAPACITY_LIMIT]: {
    id: FeatureFlags.PARTICIPANT_GROUP_CAPACITY_LIMIT,
    enabled: false,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471, 36681, 37503],
  },
  [FeatureFlags.COUPON_CODES]: {
    id: FeatureFlags.COUPON_CODES,
    enabled: false,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471, 36681, 37503],
  },
  [FeatureFlags.AUTOMATIC_DISCOUNTS]: {
    id: FeatureFlags.AUTOMATIC_DISCOUNTS,
    enabled: false,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471, 36681, 37503],
  },
  [FeatureFlags.DUPLICATE_FORM_REG_2]: {
    id: FeatureFlags.DUPLICATE_FORM_REG_2,
    enabled: false,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471, 36681, 37503],
  },
  [FeatureFlags.OFFLINE_PAYMENTS]: {
    id: FeatureFlags.OFFLINE_PAYMENTS,
    enabled: false,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471, 36681, 37503],
  },
  [FeatureFlags.AUTO_ROSTERING]: {
    id: FeatureFlags.AUTO_ROSTERING,
    enabled: false,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471],
    allowedOrgsInStaging: [974, 1522, 1530, 1359, 1373, 1136, 1353],
  },
  [FeatureFlags.TABLE_REVAMP]: {
    id: FeatureFlags.TABLE_REVAMP,
    enabled: true,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471],
    allowedOrgsInStaging: [974, 1522, 1530, 1359, 1373, 1136, 1353, 1384, 1320],
  },
  [FeatureFlags.ORG_INVOICING]: {
    id: FeatureFlags.ORG_INVOICING,
    enabled: true,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471],
    allowedOrgsInStaging: [974],
  },
  [FeatureFlags.ADD_ONS]: {
    id: FeatureFlags.ADD_ONS,
    enabled: false,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471],
    allowedOrgsInStaging: [
      974, 1522, 1530, 1359, 1373, 1136, 1353, 1384, 1, 1320, 1349, 970,
    ],
  },
  [FeatureFlags.NGB_INTEGRATIONS]: {
    id: FeatureFlags.NGB_INTEGRATIONS,
    enabled: false,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471, 52835],
    allowedOrgsInStaging: [
      974, 1522, 1530, 1359, 1373, 1136, 1353, 1384, 1, 1320, 1349, 970, 1520,
      2163,
    ],
  },
  [FeatureFlags.HCR_REG_2]: {
    id: FeatureFlags.HCR_REG_2,
    enabled: false,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [17843],
    allowedOrgsInStaging: [
      974, 1522, 1530, 1359, 1373, 1136, 1353, 1384, 1, 1320, 1349, 970, 1520,
      2243, 2163,
    ],
  },
  [FeatureFlags.FEE_SUMMARY_EXPORT]: {
    id: FeatureFlags.FEE_SUMMARY_EXPORT,
    enabled: true,
    allowedEnvironments: ['staging', 'local'],
    allowedOrgsInProd: [36471, 47271],
    allowedOrgsInStaging: [974, 1522, 1530, 1359, 1373, 1136, 1353, 1384, 1320],
  }
};
